import React from 'react';
import styles from './Page.module.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Page = ({ children, noPadding }) => {
    return (
        <div className={styles['page-container']}>
            <div
                className={classNames(styles['center-container'], {
                    [styles['center-container--no-padding']]: noPadding
                })}
            >
                {children}
            </div>
        </div>
    );
};

export default Page;

Page.propTypes = {
    children: PropTypes.node,
    noPadding: PropTypes.bool
};
